import { createTopic } from '../lib';
import { z } from 'zod';

const marketplaceCatalogNavigatedEventSchema = z.object({
  path: z.string(),
});

export type MarketplaceCatalogNavigatedEvent = z.infer<
  typeof marketplaceCatalogNavigatedEventSchema
>;

export const marketplaceCatalogNavigatedTopic =
  createTopic<MarketplaceCatalogNavigatedEvent>(
    {
      namespace: 'marketplace',
      name: 'catalog-navigated',
      description: 'User navigated to marketplace catalog.',
    },
    marketplaceCatalogNavigatedEventSchema,
  );
